import type { TextFieldProps } from './textField.types'

import { createContext } from '../utils'

const [TextFieldProvider, useTextFieldContext] = createContext<Partial<TextFieldProps> & { id?: string }>({
  isOptional: true,
})

export { TextFieldProvider, useTextFieldContext }
